/**
 * @flow
 * @relayHash 915bcc5bb04a47c9f87c0ef1e67649c6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateVendorInput = {|
  id: string,
  name?: ?string,
  email?: ?string,
  phone?: ?string,
  phone2?: ?string,
  fax?: ?string,
  address?: ?string,
  city?: ?string,
  state?: ?string,
  zipCode?: ?string,
  country?: ?string,
  paymentTerms?: ?string,
  rating?: ?number,
  notes?: ?string,
|};
export type UpdateVendorMutationVariables = {|
  input: UpdateVendorInput
|};
export type UpdateVendorMutationResponse = {|
  +updateVendor: {|
    +vendor: {|
      +id: string,
      +vendorNumber: string,
      +name: string,
      +email: ?string,
      +phone: ?string,
      +address: ?string,
      +city: ?string,
      +state: ?string,
      +zipCode: ?string,
      +country: ?string,
      +paymentTerms: ?string,
      +rating: ?number,
      +createdAt: any,
      +updatedAt: any,
      +itemPrices: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: {|
            +id: string,
            +item: {|
              +id: string,
              +name: string,
            |},
            +unitPrice: number,
            +leadTimeDays: number,
            +isPreferred: boolean,
          |}
        |}>
      |},
    |}
  |}
|};
export type UpdateVendorMutation = {|
  variables: UpdateVendorMutationVariables,
  response: UpdateVendorMutationResponse,
|};
*/


/*
mutation UpdateVendorMutation(
  $input: UpdateVendorInput!
) {
  updateVendor(input: $input) {
    vendor {
      id
      vendorNumber
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      paymentTerms
      rating
      createdAt
      updatedAt
      itemPrices {
        edges {
          node {
            id
            item {
              id
              name
            }
            unitPrice
            leadTimeDays
            isPreferred
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateVendorInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateVendor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateVendorPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendor",
        "storageKey": null,
        "args": null,
        "concreteType": "Vendor",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vendorNumber",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zipCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "paymentTerms",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rating",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemPrices",
            "storageKey": null,
            "args": null,
            "concreteType": "VendorItemPriceConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "VendorItemPriceEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorItemPrice",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "unitPrice",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "leadTimeDays",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPreferred",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateVendorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateVendorMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateVendorMutation",
    "id": null,
    "text": "mutation UpdateVendorMutation(\n  $input: UpdateVendorInput!\n) {\n  updateVendor(input: $input) {\n    vendor {\n      id\n      vendorNumber\n      name\n      email\n      phone\n      address\n      city\n      state\n      zipCode\n      country\n      paymentTerms\n      rating\n      createdAt\n      updatedAt\n      itemPrices {\n        edges {\n          node {\n            id\n            item {\n              id\n              name\n            }\n            unitPrice\n            leadTimeDays\n            isPreferred\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c645de158c09225c077fef77ee1572ce';
module.exports = node;
